import { render, staticRenderFns } from "./environmentBanner.vue?vue&type=template&id=cb45ce38&scoped=true"
import script from "./environmentBanner.vue?vue&type=script&lang=js"
export * from "./environmentBanner.vue?vue&type=script&lang=js"
import style0 from "./environmentBanner.vue?vue&type=style&index=0&id=cb45ce38&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb45ce38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb45ce38')) {
      api.createRecord('cb45ce38', component.options)
    } else {
      api.reload('cb45ce38', component.options)
    }
    module.hot.accept("./environmentBanner.vue?vue&type=template&id=cb45ce38&scoped=true", function () {
      api.rerender('cb45ce38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugin/backgroundPlugin/environmentBanner.vue"
export default component.exports